export const UPDATE_GROUP_TYPES = 'UPDATE_GROUP_TYPES';
export const SET_GROUP_TYPE = 'SET_GROUP_TYPE';
export const DELETE_GROUP_TYPE = 'DELETE_GROUP_TYPE';
